/**
 * CBM (m³) from dimensions. unit: 'cm' | 'inch' | 'feet'
 */
export function computeCbmFromDimensions(unit, l, w, h) {
  const length = parseFloat(l);
  const width = parseFloat(w);
  const height = parseFloat(h);
  if (Number.isNaN(length) || Number.isNaN(width) || Number.isNaN(height)) return '';
  let L = length;
  let W = width;
  let H = height;
  if (unit === 'inch') {
    const c = 2.54;
    L = length * c;
    W = width * c;
    H = height * c;
  } else if (unit === 'feet') {
    const c = 30.48;
    L = length * c;
    W = width * c;
    H = height * c;
  }
  const cbm = (L * W * H) / 1_000_000;
  return cbm.toFixed(2);
}
